import React from "react";
import { Container } from "@mui/material";
import Mockup from "./components/EntireComponent";

const App = () => {
  return (
    <Container>
      <Mockup />
    </Container>
  );
};

export default App;
